// Checklist padrão de inspeção visual de veículos
export const CHECKLIST_TEMPLATE = [
    {
        categoria: "Documentação",
        itens: [
            "CRLV (documento do veículo) atualizado",
            "CNH do motorista válida",
            "Seguro obrigatório (DPVAT)",
        ],
    },
    {
        categoria: "Parte externa",
        itens: [
            "Faróis (alto e baixo)",
            "Lanternas traseiras",
            "Luz de freio",
            "Setas (dianteiras e traseiras)",
            "Pisca alerta",
            "Pneus (estado e calibragem)",
            "Estepe em condições",
            "Carroceria (amassados/arranhões)",
            "Retrovisores",
            "Para-brisa e vidros",
            "Placas (dianteira e traseira)",
            "Limpador de para-brisa",
        ],
    },
    {
        categoria: "Parte interna",
        itens: [
            "Cintos de segurança",
            "Bancos e estofados",
            "Buzina",
            "Painel (luzes de aviso)",
            "Hodômetro funcionando",
            "Ar condicionado / ventilação",
        ],
    },
    {
        categoria: "Mecânica",
        itens: [
            "Nível do óleo do motor",
            "Água do radiador",
            "Fluido de freio",
            "Freios (funcionamento)",
            "Direção",
            "Embreagem / câmbio",
            "Combustível suficiente",
            "Bateria",
        ],
    },
    {
        categoria: "Segurança",
        itens: [
            "Extintor de incêndio (validade)",
            "Triângulo de sinalização",
            "Macaco",
            "Chave de roda",
            "Kit de primeiros socorros",
            "Colete refletivo",
        ],
    },
];

export function flattenChecklist() {
    const out = [];
    for (const cat of CHECKLIST_TEMPLATE) {
        for (const item of cat.itens) {
            out.push({ categoria: cat.categoria, label: item, status: "ok", observacao: "" });
        }
    }
    return out;
}
